export default __webpack_public_path__ + "static/media/crane-grab-scrap.f63855a1.jpg";